import { CodeCommand } from "commands/CodeCommand";
import { EmailCommand } from "commands/EmailCommand";
import { ChangePasswordCommand } from "commands/account/ChangePasswordCommand";
import { EmailLoginCommand } from "commands/account/EmailLoginCommand";
import { RecoverPasswordCommand } from "commands/account/RecoverPasswordCommand";
import { RegisterTeacherCommand } from "commands/account/RegisterTeacherCommand";
import { RegisterStudentCommand } from "commands/account/RegisterStudentCommand";
import { sessionId } from "contexts/GlobalContext";
import { GlobalDataResult } from "results/account/GlobalDataResult";
import { useApiService } from "services/ApiService";
import { TeacherLoginResult } from "results/account/TeacherLoginResult";
import { CodeLoginResult } from "results/account/CodeLoginResult";
import { RecoverPasswordResult } from "results/account/RecoverPasswordResult";
import { RegisterStudentResult } from "results/account/RegisterStudentResult";
import { SuccessResult } from "results/SuccessResult";
import { VerifyRegistrationCodeCommand } from "commands/account/VerifyRegistrationCodeCommand";
import { VerifyReferrerCodeResult } from "results/account/VerifyReferrerCodeResult";
import { VerifySchoolCodeResult } from "results/account/VerifySchoolCodeResult";
import { VerifyEmailResult } from "results/account/VerifyEmailResult";
import { VerifyClassCodeResult } from "results/account/VerifyClassCodeResult";
import { GoogleLoginCommand } from "commands/account/GoogleLoginCommand";

export const AccountApiService = () => {
    const { get, post } = useApiService({ controller: "/account" });

    return {
        loginEmail: (command: EmailLoginCommand) => post<TeacherLoginResult>("/login-email", { ...command, sessionId }),
        loginGoogle: (command: GoogleLoginCommand) =>
            post<TeacherLoginResult>("/login-google", { ...command, sessionId }),
        loginCode: (command: CodeCommand) => post<CodeLoginResult>("/login-code", { ...command, sessionId }),
        registerTeacher: (command: RegisterTeacherCommand) =>
            post<TeacherLoginResult>("/register-teacher", { ...command, sessionId }),
        registerEmail: (command: EmailCommand) => post("/register-email", command),
        registerGoogle: (command: CodeCommand) => post<VerifyEmailResult>("/register-google", command),
        registerStudent: (command: RegisterStudentCommand) => post<RegisterStudentResult>("/register-student", command),
        changePassword: (command: ChangePasswordCommand) => post("/change-password", command),
        forgotPassword: (command: EmailCommand) => post("/forgot-password", command),
        getRecoverPassword: (hash: string) => get<SuccessResult>(`/recover-password/${hash}`),
        recoverPassword: (command: RecoverPasswordCommand) => post<RecoverPasswordResult>("/recover-password", command),
        getGlobalUserData: () => get<GlobalDataResult>("/global-data"),
        verifyRegistrationCode: (command: VerifyRegistrationCodeCommand) =>
            post<VerifyEmailResult>("/verify-registration-code", command),
        verifyClassCode: (command: CodeCommand) => post<VerifyClassCodeResult>("/verify-class-code", command),
        verifyReferrerCode: (command: CodeCommand) => post<VerifyReferrerCodeResult>("/verify-referrer-code", command),
        verifySchoolCode: (command: CodeCommand) => post<VerifySchoolCodeResult>("/verify-school-code", command),
    };
};
